import React from 'react';
import {NavBarElement, NavTitle, NavLinks, NavLink, NavImg, NavImageContainer} from './NavBarElements'
import {Link} from 'react-router'
import Logo_wbihz from '../../image/wbihz_rgb_white.png'
import Logo_upwr from '../../image/upwr-logotyp-pl-poziomy-biel.png'
import Logo_SKN from '../../image/logo-SKN.png'
import Logo_noc_biologow from '../../image/logo_noc_biologow.png'
import Logo_infohelix from '../../image/logo_infohelix.png'

const NavBar = () => {
    return (
        <NavBarElement>
            <NavImageContainer>
                <a href="https://upwr.edu.pl/" target="_blank" rel="noreferrer"> <NavImg src={Logo_upwr} alt="Logo Uniwersytetu Przyrodniczego we Wrocławiu"/></a>
                <a href="https://wbihz.upwr.edu.pl/" target="_blank" rel="noreferrer"><NavImg src={Logo_wbihz} alt="Logo Wydziały Biologii i Hodowli Zwierząt"/></a>
                <NavImg src={Logo_SKN} alt="Logo SKN Bioinformatyków"/>
                <a href="https://www.nocbiologow.pl/noc/index.php" target="_blank" rel="noreferrer"> <NavImg src={Logo_noc_biologow} alt="Logo nocy biologów"/></a>
                <NavImg src={Logo_infohelix} alt="Logo Infohelix"/>
            </NavImageContainer>
            <NavTitle>Noc Biologów 2026</NavTitle>
            <NavLinks>
                <NavLink><Link to="/">Home</Link></NavLink>
                <NavLink><Link to="/granice">Granice</Link></NavLink>
                <NavLink><Link to="/Bakterie">☣️ Bakterie 🧫</Link></NavLink>
                <NavLink><Link to="/wilk-owca">🐺 Wilki 🐑</Link></NavLink>
                <NavLink><Link to="/zombie">🦠 Zombie 🧟</Link></NavLink>
            </NavLinks>
        </NavBarElement>
    )
}

export default NavBar;
